import { Record as record } from 'immutable';
import joi from 'joi';

import config from '../../../../src/config';
import Claim from '../delayRepay/Claim';
import Payment from '../Payment';
import Address from '../../../../src/records/customer/Address';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, fields, resolve } from '../../../../src/helpers/LinkMapper';
import ValidationMixin from '../../../../src/records/ValidationMixin';
import validation from '../../../../src/validation';

const fieldSchema = {
    claim: [ resolve.as(Claim) ],
    payment: [ resolve.as(Payment), new Payment() ],
    address: [ resolve.as(Address), new Address() ],
    storedAddress: [ resolve.as(Address) ],
    useClaimAddress: [ fields.bool ],
    phoneNumber: [ fields.string ],
    editDelayLength: [ fields.bool ],
    delayLength: [ fields.string ],
    additionalInformation: [ fields.string ]
};

export default class AutoDrClaimForm extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(AutoDrClaimForm, json, getResolvers(fieldSchema));
    }

    static create (claim, user) {
        const address = claim.getIn(['customer', 'address'], new Address())
            .set('contactName', user.fullName);
        return new AutoDrClaimForm({
            claim,
            address,
            useClaimAddress: address.isComplete(),
            payment: new Payment({ paypalEmail: claim.customer.email }),
            phoneNumber: claim.getIn(['customer', 'phoneNumber']) || user.telephoneNumber,
        });
    }

    get originalDelayLength () {
        return this.claim.getIn(['delay', 'length']);
    }

    getComputedValues () {
        return {
            address: !!this.storedAddress || (this.address && this.address.isComplete()),
            payment: this.payment.isComplete()
        };
    }

    getSchema () {
        const delayRepayTimes = config.get('delayRepayTimes').map((time) => time.value).toJS();

        return {
            payment: validation.true(),
            address: validation.true(),
            phoneNumber: validation.phone().required(),
            delayLength: joi.when('editDelayLength', {
                is: true,
                then: validation.allowOnly(delayRepayTimes).required(),
                otherwise: joi.any()
            }),
            additionalInformation: joi.when('editDelayLength', {
                is: true,
                then: validation.requiredString(20, 250),
                otherwise: joi.any()
            })
        };
    }

    getAvailableDelayLengths () {
        const { claim } = this;
        const getDelayMin = (time) => parseInt(time.replace(/\D.*/, ''), 10);

        const delayLength = getDelayMin(claim.delay.length);
        return config.get('delayRepayTimes')
            .filter(time => getDelayMin(time.value) > delayLength);
    }

}

Object.assign(AutoDrClaimForm.prototype, ValidationMixin);
